(function () {
  "use strict";
  if (window.__psBf26Mounted) return;
  const dialog = document.getElementById("ps-bf26-dialog");
  if (!dialog || typeof dialog.showModal !== "function") return;
  window.__psBf26Mounted = true;
  const start = Date.parse(dialog.dataset.psBf26Start);
  const end = Date.parse(dialog.dataset.psBf26End);
  const sessionKey = "ps-bf26-dismissed-2026";
  const sessionStartKey = "ps-bf26-session-start-2026";
  const popupDelay = 18000;
  const sessionStartedAt = readSessionStartedAt();
  const closeButton = dialog.querySelector("[data-ps-bf26-close]");
  const shopButton = dialog.querySelector("[data-ps-bf26-shop]");
  const fields = Object.fromEntries(["days", "hours", "minutes", "seconds"].map(function (key) {
    return [key, dialog.querySelector('[data-ps-bf26-time="' + key + '"]')];
  }));
  let returnFocus = null;
  let timer = null;
  let dismissedInDocument = false;
  function readSessionStartedAt() {
    const now = Date.now();
    try {
      const saved = Number(sessionStorage.getItem(sessionStartKey));
      if (Number.isFinite(saved) && saved > 0 && saved <= now) return saved;
    } catch (error) {}
    const navigationStart = window.performance && window.performance.timeOrigin;
    const startedAt = Number.isFinite(navigationStart) && navigationStart > 0 && navigationStart <= now ? navigationStart : now;
    try { sessionStorage.setItem(sessionStartKey, String(startedAt)); } catch (error) {}
    return startedAt;
  }
  function campaignIsLive() {
    const now = Date.now();
    return Number.isFinite(start) && Number.isFinite(end) && now >= start && now < end;
  }
  function dismissed() {
    if (dismissedInDocument) return true;
    try { return sessionStorage.getItem(sessionKey) === "1"; } catch (error) { return false; }
  }
  function markDismissed() {
    dismissedInDocument = true;
    try { sessionStorage.setItem(sessionKey, "1"); } catch (error) {}
  }
  function renderCountdown() {
    const remaining = Math.max(0, Math.ceil((end - Date.now()) / 1000));
    const values = {
      days: Math.floor(remaining / 86400),
      hours: Math.floor(remaining % 86400 / 3600),
      minutes: Math.floor(remaining % 3600 / 60),
      seconds: remaining % 60
    };
    Object.keys(values).forEach(function (key) { fields[key].textContent = String(values[key]).padStart(2, "0"); });
    if (!campaignIsLive() && dialog.open) dialog.close("expired");
  }
  function dismissPopup() {
    markDismissed();
    if (dialog.open) dialog.close("dismissed");
  }
  function openPopup() {
    if (!campaignIsLive() || dismissed() || dialog.open || dialog.dataset.psBf26Currency !== "USD") return;
    if (document.querySelector('dialog[open], cart-drawer.active, .ps-drawer-root[open], .header__search details[open], quick-add-modal[open]')) return;
    returnFocus = document.activeElement;
    renderCountdown();
    dialog.showModal();
    document.documentElement.classList.add("ps-bf26-scroll-locked");
    dialog.focus({ preventScroll: true });
    timer = window.setInterval(renderCountdown, 1000);
  }
  closeButton.addEventListener("click", dismissPopup);
  shopButton.addEventListener("click", dismissPopup);
  dialog.addEventListener("cancel", function (event) {
    event.preventDefault();
    dismissPopup();
  });
  dialog.addEventListener("click", function (event) {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dismissPopup();
  });
  dialog.addEventListener("close", function () {
    if (timer !== null) window.clearInterval(timer);
    timer = null;
    document.documentElement.classList.remove("ps-bf26-scroll-locked");
    if (returnFocus && returnFocus.isConnected && typeof returnFocus.focus === "function") returnFocus.focus({ preventScroll: true });
  });
  dialog.addEventListener("keydown", function (event) {
    if (event.key !== "Tab") return;
    const focusable = [closeButton, shopButton].filter(function (element) { return element.getClientRects().length; });
    if (!focusable.length) return;
    const first = focusable[0], last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  function scheduleOpen() {
    if (campaignIsLive() && !dismissed() && dialog.dataset.psBf26Currency === 'USD') {
      dialog.querySelector('.ps-bf26-popup-logo').loading = 'eager';
      if (window.matchMedia('(min-width: 651px)').matches) dialog.querySelector('.ps-bf26-popup-photo img').loading = 'eager';
      const elapsed = Math.max(0, Date.now() - sessionStartedAt);
      window.setTimeout(openPopup, Math.max(0, popupDelay - elapsed));
    }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", scheduleOpen, { once: true });
  else scheduleOpen();
})();



